/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const currencySymbolEnumSchema = z
	.enum(["₽", "$", "₸", "€", "₾", "֏", "AED"])
	.describe("* `₽` - RUB\n* `$` - USD\n* `₸` - KZT\n* `€` - EUR\n* `₾` - GEL\n* `֏` - AMD\n* `AED` - AED");
